export default __webpack_public_path__ + "static/media/opticalscompleted.968be9de.svg";